(() => {
  const modal = document.getElementById('ProductCardVariantModal');
  const body = modal?.querySelector('[data-variant-modal-body]');
  const configEl = document.getElementById('product-card-variant-modal-config');

  if (!modal || !body) return;

  const config = configEl ? JSON.parse(configEl.textContent || '{}') : {};
  const goodIconUrl = config.goodIconUrl || '';

  const handleize = (value) =>
    String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const parseJsonAttr = (value, fallback) => {
    try {
      return JSON.parse(value || JSON.stringify(fallback));
    } catch (error) {
      console.warn('product-card-variant-modal: JSON inválido', error, value);
      return fallback;
    }
  };

  const applySwatchImage = (element, value) => {
    if (!element || !value) return;
    const cssValue = String(value).trim();
    element.style.setProperty(
      '--swatch-image',
      cssValue.startsWith('url(') || cssValue.startsWith('linear-gradient(')
        ? cssValue
        : `url('${cssValue}')`
    );
  };

  const optionDisplayLabel = (value) =>
    typeof window.variantOptionDisplayLabel === 'function'
      ? window.variantOptionDisplayLabel(value)
      : String(value || '');

  const formatOptionHeading = (optionName, selectedValue) =>
    selectedValue ? `${optionName} — ${optionDisplayLabel(selectedValue)}` : optionName;

  const formatMoney = (cents) => {
    if (typeof window.formatCurrency === 'function') {
      return window.formatCurrency(cents);
    }

    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }

    return '$' + (Number(cents) / 100).toFixed(2);
  };

  const getSelectableOptions = (options) =>
    options.filter((option) => option.name !== 'Title');

  const getVariantImage = (variant, fallback) => {
    if (variant?.featured_image?.src) return variant.featured_image.src;
    if (variant?.featured_media?.preview_image?.src) return variant.featured_media.preview_image.src;
    return fallback;
  };

  const renderPrice = (container, variant) => {
    if (!container || !variant) return;
    container.innerHTML = '';

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      const compare = document.createElement('p');
      compare.className = 'product-card-variant-modal__price product-card-variant-modal__price--compare';
      compare.textContent = formatMoney(variant.compare_at_price);
      container.appendChild(compare);

      const price = document.createElement('p');
      price.className = 'product-card-variant-modal__price product-card-variant-modal__price--sale';
      price.textContent = formatMoney(variant.price);
      container.appendChild(price);
      return;
    }

    const price = document.createElement('p');
    price.className = 'product-card-variant-modal__price';
    price.textContent = formatMoney(variant.price);
    container.appendChild(price);
  };

  const getRatingDecimal = (rating) => {
    const decimal = Number(rating) % 1;
    if (decimal >= 0.3 && decimal <= 0.7) return 0.5;
    if (decimal > 0.7) return 1;
    return 0;
  };

  const buildReviews = (source, productUrl) => {
    const count = Number(source.dataset.reviewsCount || 0);
    const rating = Number(source.dataset.reviewsRating || 0);
    const scale = Number(source.dataset.reviewsScale || 5);

    if (!count || !rating) return null;

    const reviews = document.createElement(productUrl ? 'a' : 'div');
    reviews.className = 'product-card-variant-modal__reviews';
    if (productUrl) {
      reviews.href = productUrl;
    }

    const countEl = document.createElement('span');
    countEl.className = 'product-card-variant-modal__reviews-count';
    countEl.textContent = `${count} Reseñas`;

    const ratingEl = document.createElement('div');
    ratingEl.className = 'rating product-card-variant-modal__reviews-rating';
    ratingEl.setAttribute('role', 'img');
    ratingEl.setAttribute('aria-label', `${rating} de ${scale} estrellas`);

    const stars = document.createElement('span');
    stars.className = 'rating-star product-card-variant-modal__reviews-stars';
    stars.setAttribute('aria-hidden', 'true');
    stars.style.setProperty('--rating', String(Math.floor(rating)));
    stars.style.setProperty('--rating-max', String(scale));
    stars.style.setProperty('--rating-decimal', String(getRatingDecimal(rating)));

    ratingEl.appendChild(stars);
    reviews.appendChild(countEl);
    reviews.appendChild(ratingEl);
    return reviews;
  };

  const buildDescription = (description) => {
    const text = String(description || '').trim();
    if (!text) return null;

    const descriptionEl = document.createElement('div');
    descriptionEl.className = 'product-card-variant-modal__description';

    const descriptionText = document.createElement('p');
    descriptionText.className = 'product-card-variant-modal__description-text';
    descriptionText.textContent = text;
    descriptionEl.appendChild(descriptionText);
    return descriptionEl;
  };

  const buildProductLink = (productUrl) => {
    if (!productUrl) return null;

    const wrap = document.createElement('div');
    wrap.className = 'product-card-variant-modal__product-link-wrap';

    const link = document.createElement('a');
    link.className = 'product-card-variant-modal__product-link';
    link.href = productUrl;
    link.textContent = 'Ir al producto';
    wrap.appendChild(link);
    return wrap;
  };

  const buildColorSwatches = (option, swatchFiles, selectedValue) => {
    const box = document.createElement('div');
    box.className = 'main-product-container-info-variants-box';
    box.setAttribute('option', `option${option.position}`);
    box.setAttribute('name', option.name);

    const label = document.createElement('label');
    label.className = 'main-product-container-info-variants-text';
    label.textContent = formatOptionHeading(option.name, selectedValue);
    box.appendChild(label);

    const list = document.createElement('div');
    list.className = 'main-product-container-info-variants-checkboxs';
    if (option.values.length >= 8) {
      list.classList.add('main-product-container-info-variants-checkboxs--expanded');
    }

    option.values.forEach((value) => {
      const wrapper = document.createElement('div');
      wrapper.className = `main-product-container-info-variants-checkbox-wrapper swatch-colored bg-${handleize(optionDisplayLabel(value))}`;
      wrapper.title = optionDisplayLabel(value);
      applySwatchImage(wrapper, swatchFiles[value]);

      const input = document.createElement('input');
      input.type = 'radio';
      input.className = 'main-product-container-info-variants-checkbox';
      input.name = `option-${option.position}`;
      input.value = value;
      if (selectedValue && value === selectedValue) {
        input.checked = true;
      }

      const icon = document.createElement('img');
      icon.className = 'main-product-container-info-variants-checkbox-img';
      icon.src = goodIconUrl;
      icon.alt = '';
      icon.width = 40;
      icon.height = 40;

      wrapper.appendChild(input);
      wrapper.appendChild(icon);
      list.appendChild(wrapper);
    });

    box.appendChild(list);
    return box;
  };

  const buildOptionPills = (option, selectedValue) => {
    const box = document.createElement('div');
    box.className = 'main-product-container-info-variants-box';
    box.setAttribute('option', `option${option.position}`);
    box.setAttribute('name', option.name);

    const label = document.createElement('label');
    label.className = 'main-product-container-info-variants-text';
    label.textContent = formatOptionHeading(option.name, selectedValue);
    box.appendChild(label);

    const list = document.createElement('div');
    list.className = 'main-product-container-info-variants-pills';
    list.setAttribute('role', 'radiogroup');
    list.setAttribute('aria-label', option.name);

    option.values.forEach((value) => {
      const pill = document.createElement('label');
      pill.className = 'main-product-container-info-variants-pill';

      const input = document.createElement('input');
      input.type = 'radio';
      input.className = 'main-product-container-info-variants-pill-input';
      input.name = `option-${option.position}`;
      input.value = value;
      if (selectedValue && value === selectedValue) {
        input.checked = true;
      }

      const text = document.createElement('span');
      text.className = 'main-product-container-info-variants-pill-label';
      text.textContent = optionDisplayLabel(value);

      pill.appendChild(input);
      pill.appendChild(text);
      list.appendChild(pill);
    });

    box.appendChild(list);
    return box;
  };

  const buildVariantPicker = (options, swatchFiles) => {
    const variantsRoot = document.createElement('div');
    variantsRoot.className = 'main-product-container-info-variants product-card-variant-modal__variants';

    getSelectableOptions(options).forEach((option) => {
      if (option.name === 'Color') {
        variantsRoot.appendChild(buildColorSwatches(option, swatchFiles, option.selected_value));
        return;
      }

      variantsRoot.appendChild(buildOptionPills(option, option.selected_value));
    });

    return variantsRoot;
  };

  const applyPreselectedOptions = (options, preselectedValues = {}) => {
    return options.map((option) => {
      if (option.name === 'Title') return option;
      return {
        ...option,
        selected_value: preselectedValues[option.name] || null,
      };
    });
  };

  const getSelectedOptionValues = (modalAtc, options) =>
    getSelectableOptions(options)
      .sort((a, b) => Number(a.position) - Number(b.position))
      .map((option) => {
        const radio = modalAtc.querySelector(
          `input[type="radio"][name="option-${option.position}"]:checked`
        );
        return radio?.value || null;
      });

  const isVariantSelectionComplete = (modalAtc, options) => {
    const selectedValues = getSelectedOptionValues(modalAtc, options);
    return selectedValues.length > 0 && selectedValues.every(Boolean);
  };

  const resolveVariantFromModal = (modalAtc, variants, options) => {
    if (!isVariantSelectionComplete(modalAtc, options)) return null;

    const selectedValues = getSelectedOptionValues(modalAtc, options);

    return (
      variants.find((variant) =>
        variant.options.every((value, index) => value === selectedValues[index])
      ) || null
    );
  };

  const isPreselectionComplete = (options, preselectedValues) =>
    getSelectableOptions(options).every((option) => Boolean(preselectedValues[option.name]));

  const resolveVariantFromPreselected = (variants, options, preselectedValues) => {
    if (!isPreselectionComplete(options, preselectedValues)) return null;

    const selectedValues = getSelectableOptions(options)
      .sort((a, b) => Number(a.position) - Number(b.position))
      .map((option) => preselectedValues[option.name]);

    return (
      variants.find((variant) =>
        variant.options.every((value, index) => value === selectedValues[index])
      ) || null
    );
  };

  const resetMediaSlider = (mediaEl) => {
    if (!mediaEl) return;
    applyMediaEmphasis(mediaEl, null);
    mediaEl.scrollTo({ left: 0, behavior: 'auto' });
    updateMediaFade(mediaEl);
  };

  const getProductImages = (productImages, fallback) => {
    if (Array.isArray(productImages) && productImages.length) {
      return productImages;
    }

    if (fallback) {
      return [{ src: fallback, id: null, alt: '' }];
    }

    return [];
  };

  const updateMediaFade = (mediaEl) => {
    if (!mediaEl) return;

    const track = mediaEl.querySelector('.product-card-variant-modal__media-track');
    if (!track) return;

    const hasOverflow = track.scrollWidth > mediaEl.clientWidth + 1;
    const atEnd = mediaEl.scrollLeft + mediaEl.clientWidth >= track.scrollWidth - 1;

    mediaEl.classList.toggle(
      'product-card-variant-modal__media--fade-end',
      hasOverflow && !atEnd
    );
  };

  const findActiveImageIndex = (mediaEl, variant, fallbackImage) => {
    const slides = [...mediaEl.querySelectorAll('.product-card-variant-modal__media-slide')];
    if (!slides.length) return 0;

    const variantImageId =
      variant?.featured_image?.id || variant?.featured_media?.preview_image?.id;
    const variantSrc = getVariantImage(variant, fallbackImage);

    if (variantImageId) {
      const matchById = slides.findIndex(
        (slide) => Number(slide.dataset.imageId) === Number(variantImageId)
      );
      if (matchById >= 0) return matchById;
    }

    if (variantSrc) {
      const matchBySrc = slides.findIndex((slide) => {
        const image = slide.querySelector('img');
        const slideSrc = image?.currentSrc || image?.src;
        return slideSrc === variantSrc || variantSrc.includes(slideSrc);
      });
      if (matchBySrc >= 0) return matchBySrc;
    }

    return 0;
  };

  const getVariantImageId = (variant) =>
    variant?.featured_image?.id || variant?.featured_media?.preview_image?.id || null;

  const getColorOption = (options) =>
    getSelectableOptions(options).find((option) => option.name === 'Color') || null;

  const getSelectedColorValue = (modalAtc, options) => {
    const colorOption = getColorOption(options);
    if (!colorOption) return null;

    const radio = modalAtc.querySelector(
      `input[type="radio"][name="option-${colorOption.position}"]:checked`
    );

    return radio?.value || null;
  };

  const getImageIdsForColor = (variants, options, colorValue) => {
    const colorOption = getColorOption(options);
    if (!colorOption || !colorValue) return [];

    const colorIndex = Number(colorOption.position) - 1;
    const ids = variants
      .filter((variant) => variant.options[colorIndex] === colorValue)
      .map(getVariantImageId)
      .filter(Boolean);

    return [...new Set(ids.map(Number))];
  };

  const applyMediaEmphasis = (mediaEl, activeImageIds) => {
    if (!mediaEl) return;

    const ids = Array.isArray(activeImageIds) ? activeImageIds.map(Number) : [];
    const hasActiveImages = ids.length > 0;

    mediaEl.querySelectorAll('.product-card-variant-modal__media-slide').forEach((slide) => {
      const imageId = Number(slide.dataset.imageId);
      slide.classList.toggle(
        'product-card-variant-modal__media-slide--dimmed',
        hasActiveImages && !ids.includes(imageId)
      );
    });
  };

  const syncMediaToColor = (mediaEl, variants, options, colorValue) => {
    if (!mediaEl || !colorValue) return false;

    const imageIds = getImageIdsForColor(variants, options, colorValue);
    applyMediaEmphasis(mediaEl, imageIds);

    if (!imageIds.length) return false;

    const activeSlide = [...mediaEl.querySelectorAll('.product-card-variant-modal__media-slide')]
      .find((slide) => imageIds.includes(Number(slide.dataset.imageId)));

    activeSlide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    updateMediaFade(mediaEl);

    return Boolean(activeSlide);
  };

  const buildMediaSlider = (productImages, fallback, title) => {
    const media = document.createElement('div');
    media.className = 'product-card-variant-modal__media';

    const track = document.createElement('div');
    track.className = 'product-card-variant-modal__media-track';

    getProductImages(productImages, fallback).forEach(({ src, id, alt }) => {
      const slide = document.createElement('div');
      slide.className = 'product-card-variant-modal__media-slide';
      if (id) {
        slide.dataset.imageId = String(id);
      }

      const image = document.createElement('img');
      image.className = 'product-card-variant-modal__image';
      image.loading = 'lazy';
      image.src = src;
      image.alt = alt || title || '';
      slide.appendChild(image);
      track.appendChild(slide);
    });

    media.appendChild(track);

    media.addEventListener('scroll', () => updateMediaFade(media), { passive: true });

    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => updateMediaFade(media));
      resizeObserver.observe(media);
    }

    return media;
  };

  const syncMediaSlider = (mediaEl, variant, fallbackImage) => {
    if (!mediaEl || !variant) return;

    const slides = mediaEl.querySelectorAll('.product-card-variant-modal__media-slide');
    const activeIndex = findActiveImageIndex(mediaEl, variant, fallbackImage);
    const activeSlide = slides[activeIndex];

    activeSlide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    updateMediaFade(mediaEl);
  };

  const getDefaultVariant = (variants, sourceVariantId) =>
    variants.find((variant) => variant.id === Number(sourceVariantId)) ||
    variants.find((variant) => variant.available) ||
    variants[0] ||
    null;

  const updateModalButton = (button, options, variant, selectionComplete, selectedColor, form) => {
    if (!button) return;

    const hasColorOption = Boolean(getColorOption(options));
    const needsColor = hasColorOption && !selectedColor;
    const isSoldOut = Boolean(variant) && variant.available === false;
    const notifyButton = form?.querySelector('.product-card-variant-modal__notify');

    if (form) {
      form.classList.toggle('is-sold-out', selectionComplete && isSoldOut);
    }

    if (notifyButton) {
      notifyButton.hidden = !(selectionComplete && isSoldOut);
      if (variant?.id) {
        notifyButton.dataset.variantId = String(variant.id);
      }
    }

    if (needsColor) {
      button.textContent = 'Seleccionar color';
      button.disabled = true;
      button.classList.add('is-color-selection-required');
      return;
    }

    button.classList.remove('is-color-selection-required');

    if (!selectionComplete || !variant) {
      button.textContent = 'Agregar';
      button.disabled = true;
      return;
    }

    if (!variant.available) {
      button.textContent = 'Agotado';
      button.disabled = true;
      return;
    }

    button.textContent = 'Agregar';
    button.disabled = false;
  };

  const syncModalSummary = (modalAtc, variants, fallbackImage, mediaEl, priceValuesEl, options, defaultVariant) => {
    const selectionComplete = isVariantSelectionComplete(modalAtc, options);
    const variant = selectionComplete ? resolveVariantFromModal(modalAtc, variants, options) : null;
    const button = modalAtc.querySelector('[btwn]');
    const form = modalAtc.querySelector('[data-variant-modal-buy-buttons]');
    const hiddenId = modalAtc.querySelector('input[name="id"]');
    const selectedColor = getSelectedColorValue(modalAtc, options);
    const didSyncColor = selectedColor
      ? syncMediaToColor(mediaEl, variants, options, selectedColor)
      : false;

    if (selectionComplete && variant) {
      if (!didSyncColor) {
        syncMediaSlider(mediaEl, variant, fallbackImage);
      }
      renderPrice(priceValuesEl, variant);
      modalAtc.setAttribute('variant-id', String(variant.id));
      if (hiddenId) hiddenId.value = String(variant.id);
    } else {
      if (!selectedColor) {
        resetMediaSlider(mediaEl);
      }
      renderPrice(priceValuesEl, defaultVariant);
      modalAtc.setAttribute('variant-id', '');
      if (hiddenId) hiddenId.value = '';
    }

    if (button) {
      updateModalButton(button, options, variant, selectionComplete, selectedColor, form);
    }

    getSelectableOptions(options).forEach((option) => {
      const box = modalAtc.querySelector(
        `.main-product-container-info-variants-box[name="${CSS.escape(option.name)}"]`
      );
      const label = box?.querySelector('.main-product-container-info-variants-text');
      if (!label) return;

      const radio = modalAtc.querySelector(
        `input[type="radio"][name="option-${option.position}"]:checked`
      );
      const selected = radio?.value || option.selected_value;
      label.textContent = formatOptionHeading(option.name, selected);
    });
  };

  const open = (source, preselectedValues = {}, openerEl = null) => {
    const variants = parseJsonAttr(source.dataset.variants, []);
    const rawOptions = parseJsonAttr(source.dataset.options, []);
    const options = applyPreselectedOptions(rawOptions, preselectedValues);
    const swatchFiles = parseJsonAttr(source.dataset.swatchFiles, {});
    const title = source.dataset.productTitle || '';
    const productId = source.dataset.productId || '';
    const productHandle = source.dataset.productHandle || '';
    const productUrl = source.dataset.productUrl || '';
    const productDescription = source.dataset.productDescription || '';
    const fallbackImage = source.dataset.productImage || '';
    const productImages = parseJsonAttr(source.dataset.productImages, []);
    const selectionCompleteOnOpen = isPreselectionComplete(rawOptions, preselectedValues);
    const initialVariant = selectionCompleteOnOpen
      ? resolveVariantFromPreselected(variants, options, preselectedValues)
      : null;
    const initialVariantId = initialVariant?.id ? String(initialVariant.id) : '';
    const defaultVariant = getDefaultVariant(variants, source.getAttribute('variant-id'));
    const opener = openerEl || source.querySelector('[btwn]');
    const productData = {
      id: Number(productId) || productId,
      title,
      handle: productHandle,
      variants,
    };

    body.innerHTML = '';

    const layout = document.createElement('div');
    layout.className = 'product-card-variant-modal__layout';

    const media = buildMediaSlider(productImages, fallbackImage, title);

    const heading = document.createElement('h2');
    heading.className = 'main-product-info-title main-product-no-margin product-card-variant-modal__title';

    if (productUrl) {
      const headingLink = document.createElement('a');
      headingLink.className = 'product-card-variant-modal__title-link';
      headingLink.href = productUrl;
      headingLink.textContent = title;
      heading.appendChild(headingLink);
    } else {
      heading.textContent = title;
    }

    const prices = document.createElement('div');
    prices.className = 'product-card-variant-modal__prices';

    const priceValues = document.createElement('div');
    priceValues.className = 'product-card-variant-modal__prices-values';
    prices.appendChild(priceValues);

    const reviews = buildReviews(source, productUrl);
    if (reviews) prices.appendChild(reviews);

    const description = buildDescription(productDescription);

    const modalAtc = document.createElement('add-to-cart');
    modalAtc.className = 'product-card-variant-modal__atc';
    modalAtc.dataset.variantModal = 'true';
    modalAtc.setAttribute('variant-id', initialVariantId);
    modalAtc.setAttribute('quantity', source.getAttribute('quantity') || '1');
    modalAtc.setAttribute('data-variants', source.getAttribute('data-variants') || '[]');
    modalAtc.dataset.productTitle = title;

    const picker = buildVariantPicker(options, swatchFiles);
    modalAtc.appendChild(picker);

    const form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.className = 'product-card-variant-modal__buy-buttons';
    form.setAttribute('data-variant-modal-buy-buttons', '');
    const hiddenId = document.createElement('input');
    hiddenId.type = 'hidden';
    hiddenId.name = 'id';
    hiddenId.value = initialVariantId;
    const button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('btwn', '');
    button.className = 'collection-main-product-button';
    button.textContent = 'Agregar';
    button.disabled = true;
    const notifyButton = document.createElement('button');
    notifyButton.type = 'button';
    notifyButton.className = 'product-card-variant-modal__notify';
    notifyButton.textContent = 'Avísame cuando llegue';
    notifyButton.hidden = true;
    notifyButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const variantId =
        notifyButton.dataset.variantId ||
        modalAtc.getAttribute('variant-id') ||
        hiddenId.value;

      if (!variantId) return;

      modal.hide();
      window.setTimeout(() => {
        window._RestockRocket?.openModal?.(productData, String(variantId));
      }, 100);
    });
    form.appendChild(hiddenId);
    form.appendChild(button);
    form.appendChild(notifyButton);
    modalAtc.appendChild(form);

    const productLink = buildProductLink(productUrl);

    layout.appendChild(media);
    layout.appendChild(heading);
    layout.appendChild(prices);
    if (description) layout.appendChild(description);
    layout.appendChild(modalAtc);
    if (productLink) layout.appendChild(productLink);
    body.appendChild(layout);

    const onChange = () => {
      syncModalSummary(modalAtc, variants, fallbackImage, media, priceValues, options, defaultVariant);
    };

    modalAtc.addEventListener('change', onChange);
    modalAtc.addEventListener('variant-modal:sync-button', onChange);
    onChange();
    requestAnimationFrame(() => {
      updateMediaFade(media);
      media.querySelectorAll('img').forEach((image) => {
        if (image.complete) return;
        image.addEventListener('load', () => updateMediaFade(media), { once: true });
      });
    });

    modalAtc.addEventListener(
      'product-added',
      () => {
        modal.hide();
      },
      { once: true }
    );

    modal.show(opener);
  };

  document.addEventListener('product-card:variant-required', (event) => {
    if (!event.detail?.source) return;
    open(event.detail.source, event.detail.preselectedValues || {});
  });

  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-product-card-swatch]');
    if (!swatch) return;

    const card = swatch.closest('.collection-main-product');
    const addToCart = card?.querySelector('add-to-cart[data-requires-variant-selection="true"]');
    if (!addToCart) return;

    event.preventDefault();
    event.stopPropagation();

    open(addToCart, { Color: swatch.dataset.colorValue || '' }, swatch);
  });
})();
